var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"other"},[_c('logout'),_c('password-change'),_c('info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }